<template>
    <div class="footer">

        <div class="main-title" v-if="goodsInfo.ownerPic">人物名片</div>

        <div class="goods-img" v-if="goodsInfo.ownerPic">
            <img :src="goodsInfo.ownerPic" />
        </div>

        <div class="goods-img">
            <img src="@/assets/tel.png" @click="onPhone"/>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        goodsInfo: Object,
    },
    data() {
        return {};
    },

    methods: {
        onPhone() {
            SmartCity.makeCall({
              tel: "96345",
            });
        },
    },
};
</script>

<style scoped lang="less">
.footer {
    margin: 15px;
}
.tips {
    text-align: center;
    span:nth-child(1) {
    }
    span:nth-child(2) {
        color: #ff991d;
    }
}
.main-title {
    font-size: 16px;
    padding: 4px;

    color: #ff991d;
    margin-bottom: 10px;
}
.goods-img {
    margin-bottom: 30px;
    img {
        border-radius: 10px;
        width: 100%;
        // height: 160px;
        // height: 214px;
        // border-radius: 4px;
    }
    video {
        // border-radius: 10px;
        margin-top: 10px;

        width: 100%;
        // height: 160px;
        // height: 214px;
        // border-radius: 4px;
    }
}
</style>
